var _path, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7941 45.8308C31.0345 47.2084 29.0553 47.2102 28.2931 45.8341L10.6444 13.969C9.90611 12.636 10.8702 11 12.394 11H47.6133C49.1354 11 50.0997 12.6328 49.3647 13.9657L31.7941 45.8308Z",
    fill: "url(#paint0_linear_2956_4661)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.7715,
    y: 23.1602,
    width: 3,
    height: 10.5115,
    rx: 1.5,
    transform: "rotate(150.615 22.7715 23.1602)",
    fill: "white",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2956_4661",
    x1: 51,
    y1: 50.3907,
    x2: 13.3245,
    y2: 7.22545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43A1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBDB0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.f08f8d2a447c5bbfb8987dd279970a27.svg";
export { ForwardRef as ReactComponent };